import type {LegacyId, InputMapsInfo, SourceInfo} from "#material-maps-exporter/core/types"
import type {MapsExporterDataSource} from "#material-maps-exporter/core/data-source"
import {gatherMaterialData} from "#material-maps-exporter/core/gather-material-data"

export async function gatherMaterialDataForPbrExport(
    dataSource: MapsExporterDataSource,
    materialId: {legacyId: LegacyId} | {id: string},
): Promise<{
    mapsInfo: InputMapsInfo
    sourceInfo: SourceInfo
    materialRevisionDetails: {id: string; legacyId: number}
}> {
    const {mapsInfo, materialRevisionDetails} = await gatherMaterialData(dataSource, materialId)

    return {
        mapsInfo,
        materialRevisionDetails,
        sourceInfo: {
            type: "sourceInfo",
            source: "materialRevision",
            sourceId: materialRevisionDetails.legacyId,
            textureRevisionInfo: undefined,
        },
    }
}
